import { RegistrationState } from '@/models';
import type { FormRegistration } from '@/models';

export function pickLatestFinalRegistration(registrations: FormRegistration[]): FormRegistration | null {
  const finals = registrations.filter(registration => registration.state === RegistrationState.FINAL);
  finals.sort((a, b) => b.registered - a.registered);
  return finals[0] ?? null;
}
